var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-block","width":"100%"}},[_c('Cascader',{attrs:{"data":_vm.areaListData,"value":_vm.loadValue(),"clearable":"","transfer":"","filterable":"","change-on-select":_vm.changeOnSelect},on:{"on-change":_vm.SelectAreaEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }